export default "__VITE_ASSET__B9ye7Tog__"